<template lang="html">
  <div class="centerx" style="min-width: 1000px;">
    <vs-popup
      :title="'Contrat n° ' + contract.id + ' ' + contract.society_name"
      :active.sync="isPopupActive"
    >
      <div class="container-fluid ml-2"
        id="contractPopup"
      >
        <div class="vx-col mb-base w-full">
          <div class="vx-row w-full">
            <div class="vx-col w-2/3">
              <vs-chip
                style="width: 80px"
                :color="getContractStatusColor(contract.status)">{{
                getContractStatus(contract.status)
              }}</vs-chip>
            </div>
            <div class="vx-col w-1/3 float-right">
              <span class="mr-auto"><vs-button  @click="updateContract(contract.id)">Modifier ce contrat</vs-button></span>
            </div>
          </div>
          <div class="vx-row w-full ml-2">
            <!-- FIRST COL -->
            <div class="vx-col w-1/2">
              <div class="vx-row w-full">
                <span class="title w-full">Prestation</span>
                <span class="value">{{
                  getProductCategoryName(contract.delivery)
                }}</span>
              </div>
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Date de création{{ contract.end_date ? " - Date de fin" : ""}} {{ contract.last_update_date ? " (Date de dernière mise à jour)" : ""}}</span>
                <span class="value"
                  >{{
                    getDateToFrenchFormat(contract.start_date) || nullValueMsg
                  }}
                </span>
                <span class="value"
                v-if="contract.end_date"
                  >{{
                    "-" + getDateToFrenchFormat(contract.end_date) || nullValueMsg
                  }}
                </span>
                <span class="value"
                v-if="contract.last_update_date"
                  >{{
                    "(" + getDateToFrenchFormat(contract.last_update_date) + ")" || nullValueMsg
                  }}
                </span>
              </div>
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Consultant(e-s)</span>
                  <div class="vx-row center-content">
                    <div class="flex center" v-for="(account_manager_avatar, index) in contract.account_manager_avatars" :key="index">
                      <vx-tooltip
                          :text="account_manager_avatar.name"
                          position="top"
                      >
                          <vs-avatar
                            style="border: 1px solid;"
                            :badge="account_manager_avatar.is_lead"
                            badge-color="rgb(140, 23, 164)"
                            :text="account_manager_avatar.name"
                            :src="getCollaboratorAvatar(account_manager_avatar.users_id)"
                          />
                      </vx-tooltip>
                    </div>
                  </div>
              </div>
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Lien BC et CGV</span>
                <vx-tooltip v-if="contract.bccgv_link" :text="contract.bccgv_link" position="top">
                  <vs-button
                      v-if="contract.bccgv_link"
                      color="primary"
                      size="large"
                      type="flat"
                      icon-pack="feather"
                      icon="icon-link-2"
                      @click="downloadBccgv(contract.id)"
                  ></vs-button>
                </vx-tooltip>
                <!-- <span class="value">{{
                  contract.bccgv_link || nullValueMsg
                }}</span> -->
              </div>
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Commentaire</span>
                <span class="value">{{ contract.detail || nullValueMsg }}</span>
              </div>
            </div>
            <!-- END FIRST COL -->
            <!-- SECOND COL -->
            <div class="vx-col w-1/2">
              <div class="vx-row w-full">
                <span class="title w-full">Type</span>
                <span class="value">{{
                  getContractTypeName(contract.type) || nullValueMsg
                }}</span>
              </div>
              <!--<div class="vx-row w-full mt-2">
                <span class="title w-full">Dépense Media max</span>
                <span class="value">{{
                  contract.max_budget || nullValueMsg
                }}€</span>
              </div>
              -->
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Commercial</span>
                <vx-tooltip
                  :text="contract.commercial_name"
                  position="top"
                >
                    <vs-avatar style="border: 1px solid;" :text="contract.commercial_name" :src="getCollaboratorAvatar(contract.commercial_id)"/>
                </vx-tooltip>
              </div>
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Lien du devis</span>
                <vx-tooltip v-if="contract.estimate_link" :text="contract.estimate_link" position="top">
                  <vs-button
                    color="primary"
                    size="large"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-link-2"
                    :href="contract.estimate_link"
                    target="_blank"
                  ></vs-button>
                </vx-tooltip>

                <!-- <span class="value">{{
                  contract.estimate_link || nullValueMsg
                }}</span> -->
              </div>
              <div class="vx-row w-full mt-2">
                <span class="title w-full">Commentaire facturation</span>
                <span class="value">{{
                  contract.commentary || nullValueMsg
                }}</span>
              </div>
            </div>
            <!-- END SECOND COL -->
          </div>

          <!-- MISSIONS TABLE -->
          <div class="vx-row w-full mt-4" v-if="allMissions">
            <div class="vx-row w-full mt-4">
            <!-- <div class="vx-col title w-full">Prestations commercialisées</div> -->
            <div class="vx-col w-2/3"></div>
            <div class="vx-col w-1/3 float-right"><vs-button  @click="updateMissions(contract.id)">Modifier les prestations</vs-button></div>
            </div>
            <div class="vx-row w-full ml-2">
            <MissionPopupTable :missions="allMissions"  class="w-full" />
            </div>
          </div>

          <!-- PURCHASES table -->
          <div class="vx-row w-full mt-4">
            <div class="vx-col w-full">
              <div class="vx-row w-full">
                <span class="title w-full">Achats</span>
              </div>
              <div class="vx-row align-content-center">
                <div class="vx-col w-3/4">
                  <PurchasePopupTable :contract="contract" />
                </div>
                <div class="vx-col my-auto w-1/4">
                  <vs-button icon-pack="feather" icon="icon-shopping-cart" @click="showPurchases" >Consulter les achats</vs-button>
                </div>
              </div>
            </div>
          </div>

          <!-- TASK table -->
          <div class="vx-row w-full mt-4">
            <div class="vx-col w-full">
              <div class="vx-row w-full">
                <span class="title w-full">Tâches</span>
              </div>
              <div class="vx-row align-content-center">
                <div class="vx-col w-3/4">
                  <TaskMonitoringTable :contract="contract" />
                </div>
                <div class="vx-col my-auto w-1/4">
                  <vs-button icon-pack="feather" icon="icon-list" @click="showTasks" >Consulter les tâches</vs-button>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="vx-row w-full center mt-4">

          </div> -->
        </div>
        <vs-popup
          :title="'Achats'"
          :active.sync="purchasesDisplayed"
        >
          <PurchasesTable :purchases="allPurchases" id="purchasePopup"/>
        </vs-popup>
          <TaskHistoryPopup :tasks="contractTasks"
            :popupActive.sync="tasksDisplayed"
            :apiUrl="apiUrl"
          />
      </div>
    </vs-popup>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import Mission from "@/entities/Mission";
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import Purchase from "@/entities/Purchase";
import PurchasePopupTable from "@/components/tables/PurchasePopupTable";
import PurchasesTable from "@/components/tables/PurchasesTable";
import TaskMonitoringTable from "@/components/tables/TaskMonitoringTable";
import TaskHistoryPopup from "@/components/popups/TaskHistoryPopup";
import store from "@/store/store";

export default {
	name: "ContractInfo",
	props: {
		contract: Object,
		popupActive: Boolean,
	},
	components: {
		MissionPopupTable,
		PurchasePopupTable,
		PurchasesTable,
		TaskMonitoringTable,
		TaskHistoryPopup,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		tasks: () => {
			return store.state.tasks;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	created() {
		this.allMissions = [];
		Mission.getMissionsForContract(this.$props.contract.id, (err, res) => {
			this.allMissions = res;
		});
		this.contractTasks = [];
		for (let task of this.tasks) {
			if (task.contract_id == this.$props.contract.id) {
				this.contractTasks.push(task);
			}
		}
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	watch: {
		contract: function (data) {
			this.allMissions = [];
			Mission.getMissionsForContract(data.id, (err, res) => {
				this.allMissions = res.data;
			});
		},
		popupActive: function () {
			this.isPopupActive = this.popupActive;
		},
		isPopupActive: function () {
			this.$emit("update:popupActive", this.isPopupActive);
		},
	},
	data() {
		return {
			allMissions: [],
			allPurchases: [],
			isPopupActive: this.popupActive,
			nullValueMsg: " ",
			purchasesDisplayed: false,
			tasksDisplayed: false,
			apiUrl: store.state.backendApiUrl,
			contractTasks: [],
		};
	},
	methods: {
		showPurchases() {
			Purchase.getAllPurchasesWithRecurringForContract(
				this.contract.id,
				(err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							//console.log(res.data);
							this.allPurchases = res.data;
							this.purchasesDisplayed = true;
						}
				}
			);
		},
		showTasks() {
			//console.log("show-tasks");
			this.tasksDisplayed = true;
		},
		updateContract(contractId) {
			sessionStorage.setItem("popupOrigin", contractId);
			this.isPopupActive = false;
			this.$emit("update:popupActive", false);
			this.$emit("modify-contract", contractId);
		},

		updateMissions(contractId) {
			sessionStorage.setItem("popupOrigin", contractId);
			this.isPopupActive = false;
			this.$emit("update:popupActive", false);
			this.$emit("modify-missions", contractId);
		},
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		downloadBccgv(contractId) {
			//console.log(contractId);
			let target_url = this.apiUrl + "contract/getBccgv/" + contractId;
			this.$http
				.get(target_url, { responseType: "blob" })
				.then((fetched_bccgv) => {
					let fileURL = window.URL.createObjectURL(
						new Blob([fetched_bccgv.data])
					);
					let fileLink = document.createElement("a");
					//console.log("fetched_bccgv", fetched_bccgv);
					fileLink.href = fileURL;
					fileLink.setAttribute("download", "contract-" + contractId + ".pdf");
					document.body.appendChild(fileLink);
					fileLink.click();
				})
				.catch((err) => {
					//console.log(err);
				});
		},
	},
};
</script>

<style scoped>
.title {
	color: grey;
}

.value {
	color: black;
	font-weight: 500;
}

.center {
	justify-content: center;
}

#contractPopup {
	width: auto;
}
.con-vs-popup .vs-popup {
	width: auto;
}
</style>
